import {
  booleanOperatorSchema,
  dateOperatorSchema,
  stringOperatorSchema,
} from "../operations/operation-filter";
import z from "zod";

export const filterSouscriptionSchema = z.object({
  code: stringOperatorSchema.optional(),
  userId: stringOperatorSchema.optional(),
  rateId: stringOperatorSchema.optional(),
  paymentId: stringOperatorSchema.optional(),
  valid_from: dateOperatorSchema.optional(),
  valid_to: dateOperatorSchema.optional(),
  is_active: booleanOperatorSchema.optional(),
  createdAt: dateOperatorSchema.optional(),
});

export type FilterSouscriptionType = z.infer<typeof filterSouscriptionSchema>;
